import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=43cf3ffa&scoped=true"
import script from "./surveys.vue?vue&type=script&lang=js"
export * from "./surveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf3ffa",
  null
  
)

export default component.exports